module.exports = __webpack_public_path__ + "media/img/pages/companies/hug-9837a7f2c498a28fbb8b7c6d91133fb0.png";